import React from 'react';
import img2 from '../../../src/assets/bouns-img2.webp'
import video from '../../../src/assets/bonus-video-compress.mp4'

const Bonus = () => {
    return (
        <>
            <div className="bonus-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12  col-xl-9 col-lg-12 mx-auto width_mac">
                            <div>
                                <div className="alert-bonus">Master Your Pool: Free $59 Guide for First 100 Trialists!</div>
                                <h5 className="expert-head">140k + Pools. Precision. Unrivalled.</h5>
                                {/* <img src={img} alt="Bonus gif" className="img-bonus" width="1120" loading="lazy" /> */}
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    preload="auto"
                                    width="100%"
                                    className='img-bonus'
                                    onEnded={(e) => {
                                        e.target.currentTime = 0;
                                        e.target.play();
                                      }}
                                      loading="lazy"
                                >
                                    <source src={video} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                                <div className="align-items-center d-flex justify-content-between flex-wrap gap24 gap65 desktop-change">
                                    <div className="align-items-center d-flex">
                                        <img src={img2} alt="Bonus Image" className="reward-img" loading="lazy" />
                                        <div>
                                            <h6 className="rated-head">Created by Pool Pros with <br /> 15+ Years Experience</h6>
                                        </div>
                                    </div>
                                    <div className="mobile-w100">
                                        <button className="btn btn-bonus landing-slider-button">Try For Free — Unlock Your Bonus</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Bonus;
